.ux-w-track {
    display: block;

    .ux-w-wrapper__body {
        > div {
            display: flex;
        }
    }

    &__order-item {
        display: inline-flex;

        &:nth-of-type(even) {
            background: $color-blue-menu-bg;
        }
    }
}
